export const ChartkitMenuDialogsQA = {
    chartMenuDropDown: 'chart-dropdown-menu',
    chartMenuDropDownSwitcher: 'chart-dropdown-switcher',
    chartMenuShareModalBody: 'chart-share-modal-body',
    chartMenuExportCsvDialog: 'chart-export-csv-dialog',
    chartMenuExportCsvSelectDelimiter: 'chart-export-select-delimiter',
    chartMenuExportCsvSelectFloat: 'chart-export-select-float',
    chartMenuExportCsvSelectCharset: 'chart-export-select-charset',
    chartMenuExportCsvDecimalDelimiterDot: 'decimal-delimiter-option-dot',
    chartMenuExportCsvDecimalDelimiterComma: 'decimal-delimiter-option-comma',
    chartMenuExportCsvValueDelimiterSpace: 'value-delimiter-option-space',
    chartMenuExportCsvValueDelimiterSemicolon: 'value-delimiter-option-semicolon',
    chartMenuExportCsvValueDelimiterTab: 'value-delimiter-option-tab',
    chartMenuExportCsvValueDelimiterComma: 'value-delimiter-option-comma',
    chartMenuExportModalApplyBtn: 'chart-export-btn-apply',
    chartMenuInspectorRenderTime: 'chart-inspector-render-time',
    chartMenuInspectorNotEmpty: 'chart-inspector-not-empty',
    unsupportedAlertMsg: 'unsupported-alert-msg',
    chartMetricsYAxis: 'chart-metrics-yaxis',
    chartMetricsSeriesSelect: 'chart-metrics-series-select',
    chartAlertValInput: 'chart-alert-value-input',
    chartError: 'chartkit-error',
    chartPreview: 'chart-preview',
    errorButtonRetry: 'chartkit-error-actions',
    widgetTab: 'widget-chart-tab',
    chartWidget: 'chart-widget',
};

export const enum ChartKitQa {
    Loader = 'chartkit-loader',
    DrillBreadcrumbs = 'chartkit-drillbreadcrumbs',
    DrillBreadcrumbsItem = 'chartkit-drillbreadcrumbs-item',
    Widget = 'chart-widget',
}

export const enum ChartQa {
    Chart = 'chartkit-chart',
}

export const enum ChartKitTreeNodeStateQa {
    Opened = 'chartkit-tree-node-state-opened',
    Closed = 'chartkit-tree-node-state-closed',
}

export const enum ChartKitTableQa {
    Widget = 'chartkit-table-widget',
    HeadCellContent = 'chartkit-table-header-cell',
    CellContent = 'chartkit-cell-content',
    Paginator = 'chartkit-table-paginator',
    PaginatorPageInput = 'chartkit-table-paginator-page-input',
    PaginatorRange = 'chartkit-table-paginator-range',
    PaginatorPrevPageButton = 'chartkit-table-paginator-prev-btn',
    PaginatorNextPageButton = 'chartkit-table-paginator-next-btn',
}

export const enum ChartKitQlPreviewTableQa {
    Widget = 'chartkit-preview-table-widget',
}
